import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classNames from 'classnames';
import styles from './icon.module.less';

var useIconSize = function useIconSize(size) {
  switch (size) {
    case 'small':
      // 16px
      return '1rem';

    case 'medium':
      // 24px
      return '1.5rem';

    case 'large':
      // 32px
      return '2rem';

    case 'x-large':
      // 56px
      return '3.5rem';

    default:
      return size;
  }
};

var useIconProps = function useIconProps(_ref) {
  var _classNames;

  var size = _ref.size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
      className = _ref.className,
      textAligned = _ref.textAligned,
      props = _objectWithoutProperties(_ref, ["size", "color", "className", "textAligned"]);

  var resolvedSize = useIconSize(size);
  return _objectSpread({
    'aria-hidden': 'true',
    className: classNames(className, (_classNames = {}, _defineProperty(_classNames, styles.sized, size === undefined), _defineProperty(_classNames, styles.textAligned, textAligned), _classNames)),
    fill: color,
    focusable: 'false',
    width: resolvedSize,
    height: resolvedSize
  }, props);
};

export { useIconProps };